import { useEffect } from "react";
import { products } from "@/lib/offers";
import { CompanyHeader, offerBtn, SmartLink } from "@/components/CompanyUi";

export default function ProductsPage() {
    useEffect(() => {
        document.title = "Products — SalesCan";
        return () => {
            document.title = "SalesCan";
        };
    }, []);

    return (
        <main data-testid="products-page" className="bg-white text-[#0a0a0b]">
            <CompanyHeader
                kicker="Products"
                title="What is live. Labeled."
                subtitle="Four products you can use today. Demos on those pages are fictional — we say so on the card. Nothing else is public until it ships."
            />

            <section className="px-5 pb-20">
                <div className="mx-auto grid max-w-5xl gap-4 sm:grid-cols-2">
                    {products.map((product) => (
                        <article
                            key={product.name}
                            className="flex flex-col rounded-3xl bg-[#f6f7fb] p-6 ring-1 ring-black/5"
                        >
                            <div className="flex items-start justify-between gap-3">
                                <h2 className="font-display text-2xl font-extrabold">{product.name}</h2>
                                <span className="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-[var(--brand)] ring-1 ring-black/5">
                                    {product.status}
                                </span>
                            </div>
                            <p className="mt-3 flex-1 text-[15px] leading-relaxed text-[#5b5b66]">{product.problem}</p>
                            <p className="mt-3 text-xs leading-relaxed text-[#8a8a95]">{product.note}</p>
                            <SmartLink href={product.href} className={`mt-6 ${offerBtn}`}>
                                Open
                            </SmartLink>
                        </article>
                    ))}
                </div>
            </section>
        </main>
    );
}
